module.exports = __webpack_public_path__ + "media/lendingtree/ascent-be946187.png";